import TABS from '@/components/Tasks/constants/tabs';

const initialPageInfo = {
  has_next: false,
  next_page: null,
  total: 0,
  page: 1,
  page_size: 20,
};

const initialTaskCollection = {
  loading: true,
  loadingMore: false,
  error: false,
  pendingItems: [],
  completedItems: [],
};

const createInitialTaskCollection = () => ({
  ...initialTaskCollection,
  pendingItems: [],
  completedItems: [],
});

const createInitialAllTasksSection = () => ({
  items: [],
  loadingMore: false,
  pageInfo: { ...initialPageInfo },
  initialized: false,
});

export const createInitialAllTasksState = () => ({
  error: false,
  pending: createInitialAllTasksSection(),
  completed: createInitialAllTasksSection(),
});

const initialState = {
  refreshCount: 0,
  showModal: false,
  filters: {
    open: false,
    properties: {
      selected: [],
      data: [],
      loading: false,
      error: null,
    },
    contacts: {
      selected: [],
      data: [],
      loading: false,
      error: null,
    },
    agents: {
      selected: [],
      data: [],
      loading: false,
      error: null,
    },
  },
  tabCounts: {
    all: 0,
    future: 0,
    today: 0,
    to_review: 0,
  },
  tabTasks: {
    ...createInitialTaskCollection(),
    page_info: { ...initialPageInfo },
  },
  allTasks: createInitialAllTasksState(),
  tabs: [
    { id: TABS.TODAY, active: true },
    { id: TABS.EXPIRED, active: false },
    { id: TABS.FUTURE, active: false },
    { id: TABS.ALL, active: false },
  ],
  newTask: {
    isEditing: false,
    hasExternalAgents: false,
    title: '',
    date: new Date(),
    startTime: null,
    endTime: null,
    isAddTimeActive: false,
    contacts: {
      data: [],
      selected: [],
      loading: false,
      error: null,
    },
    properties: {
      data: [],
      selected: [],
      loading: false,
      error: null,
    },
    agents: {
      data: [],
      selected: [],
      loading: false,
      error: null,
    },
    loading: false,
    error: null,
    areConflicts: false,
    conflictEvents: {},
  },
  rightbar: {
    today: [],
    to_review: [],
    loading: true,
    error: false,
    hasInitialData: false,
  },
  originalNewTask: null, // Deep clone of newTask when opening edit (same shape)
};

export default initialState;
